import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { api_updateOrderStatus } from '../../../api/order';
import { getImageUrl } from '../../../api';

const STATUS = ['active', 'completed', 'canceled'];

const OrderDetails = () => {
    const location = useLocation();
    const { order } = location.state || {};
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState(order.status || STATUS[0]);
    const navigate = useNavigate();

    const edit = async () => {
        try {
            setLoading(true);
            const payload = {
                status: status,
            };

            const res = await api_updateOrderStatus(order._id, payload);

            const message = typeof res.message === 'string' ? res.message : 'Success';
            if (res.isSuccess) {
                toast.success(message);
                setTimeout(() => {
                    navigate(-1);
                }, 100);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (!order) return <div>No order details available</div>;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyItems: 'center',
                alignItems: 'center',
                flex: 1,
                padding: '40px',
                width: '100%'
            }}
        >
            <div className='col-6 mb-3'>
                <h3>Order Details</h3>
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='orderId' className='form-label'>
                    Order Number
                </label>
                <input
                    type='text'
                    id='orderId'
                    className='form-control'
                    value={order.orderNo}
                    readOnly
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                />
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='customerName' className='form-label'>
                    Customer Name
                </label>
                <input
                    type='text'
                    id='customerName'
                    className='form-control'
                    value={order.user.name}
                    readOnly
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                />
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='phoneNumber' className='form-label'>
                    Phone Number
                </label>
                <input
                    type='text'
                    id='phoneNumber'
                    className='form-control'
                    value={order.user.phoneNumber}
                    readOnly
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                />
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='status' className='form-label'>
                    Status
                </label>
                <select
                    onChange={(e) => setStatus(e.target.value)}
                    className='form-select'
                    aria-label='Default select example'
                    value={status}
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                >
                    <option disabled>Choose Status</option>
                    {STATUS.map((i, index) => (
                        <option key={index} value={i}>
                            {i}
                        </option>
                    ))}
                </select>
            </div>

            <div className='col-6 mb-3'>
                <label className='form-label'>Products</label>
                <ul className='list-group'>
                    {order.products.map((product: any, index: number) => (
                        <li key={index} className='list-group-item d-flex align-items-center'>
                            {product.productId.image && (
                                <img
                                    src={getImageUrl(product.productId.image)}
                                    alt={product.productId.name}
                                    style={{ width: '50px', height: '50px', marginRight: '10px' }}
                                />
                            )}
                            <div>
                                {product.productId.name} - {product.quantity} x {product.productId.onSalePrice.prefix}{product.productId.onSalePrice.amount} ({product.productId.onSalePrice.currency})
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='total' className='form-label'>
                    Total
                </label>
                <input
                    type='text'
                    id='total'
                    className='form-control'
                    value={`${order.currency} ${order.total}`}
                    readOnly
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                />
            </div>

            <div className='col-6 mb-3'>
                <label htmlFor='orderDate' className='form-label'>
                    Order Date
                </label>
                <input
                    type='text'
                    id='orderDate'
                    className='form-control'
                    value={new Date(order.createdAt).toLocaleString()}
                    readOnly
                    style={{ backgroundColor: '#343a4000', borderColor: '#343a4000' }}
                />
            </div>
        </div>
    );
};

export default OrderDetails;
